function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ARROW_SIZE, ContentWrapperDisplayModes, InteractionTypes, SPACING_FROM_ANCHOR, SPACING_FROM_NEAREST_CORNER } from './constants';
import { Arrow, PopoverContainer } from './styles';
import { AnchoredLayer } from '@doordash/component-layer-manager';
import FocusLock from '@doordash/component-focus-lock';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemingContext } from '@doordash/design-language';
import get from 'lodash.get';
import omit from 'lodash.omit';
import { withUniqueId } from '@doordash/utilities';
var PREFIX_ID = 'Popover';

var getOffsetForPosition = function getOffsetForPosition(position, includeArrowSize) {
  var adjustedSpacing = includeArrowSize ? SPACING_FROM_ANCHOR : SPACING_FROM_ANCHOR - ARROW_SIZE;

  switch (position) {
    case AnchoredLayer.Positions.TopLeft:
    case AnchoredLayer.Positions.BottomLeft:
      return [-SPACING_FROM_NEAREST_CORNER, adjustedSpacing];

    case AnchoredLayer.Positions.TopRight:
    case AnchoredLayer.Positions.BottomRight:
      return [SPACING_FROM_NEAREST_CORNER, adjustedSpacing];

    case AnchoredLayer.Positions.RightTop:
    case AnchoredLayer.Positions.LeftTop:
      return [-SPACING_FROM_NEAREST_CORNER, adjustedSpacing * 1.5];

    case AnchoredLayer.Positions.RightBottom:
    case AnchoredLayer.Positions.LeftBottom:
      return [SPACING_FROM_NEAREST_CORNER, adjustedSpacing * 1.5];

    case AnchoredLayer.Positions.TopCenter:
    case AnchoredLayer.Positions.BottomCenter:
      return [0, adjustedSpacing];

    case AnchoredLayer.Positions.RightCenter:
    case AnchoredLayer.Positions.LeftCenter:
    default:
      return [0, adjustedSpacing * 1.5];
  }
};

var Popover = /*#__PURE__*/function (_React$Component) {
  _inherits(Popover, _React$Component);

  var _super = _createSuper(Popover);

  function Popover() {
    var _this;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isVisible: _this.props.defaultIsVisible,
      isFlipped: false
    });

    _defineProperty(_assertThisInitialized(_this), "getActualPosition", function () {
      var position = _this.props.position;
      return _this.state.isFlipped ? AnchoredLayer.FlippedPositions[position] : position;
    });

    _defineProperty(_assertThisInitialized(_this), "setVisibility", function (visibility) {
      var isFunction = typeof visibility === 'function'; // If visibility is a function, keep a record of it's original
      // `isVisible` property to compare against the freshly updated state

      var previousVisibility = isFunction ? visibility(_this.state) : null;

      _this.setState(isFunction ? visibility : {
        isVisible: visibility
      }, function () {
        // Check to see if user passed in `onVisibilityChange` prop
        if (_this.props.onVisibilityChange) {
          // If `visibility` is a function (see `ToggleClick` case in
          // `getEventHandlersForInteractionType()` for example), we
          // only want to call `onVisibilityChange` if the newly
          // updated state is different than before (`previousVisibility`)
          if (isFunction) {
            if (previousVisibility.hasOwnProperty('isVisible') && previousVisibility.isVisible !== _this.state.isVisible) {
              return _this.props.onVisibilityChange(_this.state.isVisible);
            } // If `visibility` is not a function, we only want to call
            // the `onVisibilityChange` callback if visibility is different
            // than the `isVisible` prop that was passed to `Popover`

          } else if (visibility !== _this.props.isVisible) {
            return _this.props.onVisibilityChange(visibility);
          }
        }

        return null;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAnchorElement", function (ref) {
      _this.anchorElement = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setContainerElement", function (ref) {
      _this.containerElement = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setArrowElement", function (ref) {
      _this.setState({
        arrowElement: ref
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleEscapePress", function (e) {
      if (e.key === 'Escape') {
        _this.handleClose(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      } else {
        _this.setVisibility(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFlippedChange", function (_ref) {
      var flipped = _ref.flipped;
      return _this.setState({
        isFlipped: flipped
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      if (_this.containerElement && _this.containerElement.contains(e.target) || _this.anchorElement && _this.anchorElement.contains(e.target)) {
        return;
      }

      _this.handleClose(e);
    });

    _defineProperty(_assertThisInitialized(_this), "getIsVisible", function () {
      var isVisible = _this.props.isVisible;
      return typeof isVisible === 'boolean' ? isVisible : _this.state.isVisible;
    });

    _defineProperty(_assertThisInitialized(_this), "getEventHandlersForInteractionType", function () {
      switch (_this.props.interactionType) {
        case InteractionTypes.ToggleClick:
          return {
            onClick: function onClick() {
              return _this.setVisibility(function (state) {
                return {
                  isVisible: !state.isVisible
                };
              });
            }
          };

        case InteractionTypes.Controlled:
        default:
          return {};
      }
    });

    return _this;
  }

  _createClass(Popover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.getIsVisible()) {
        document.addEventListener('click', this.handleClickOutside, false);
        document.addEventListener('keyup', this.handleEscapePress, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, false);
      document.removeEventListener('keyup', this.handleEscapePress, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      document.removeEventListener('click', this.handleClickOutside, false);
      document.removeEventListener('keyup', this.handleClickOutside, false);

      if (this.getIsVisible()) {
        document.addEventListener('click', this.handleClickOutside, false);
        document.addEventListener('keyup', this.handleEscapePress, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          boundariesElement = _this$props.boundariesElement,
          content = _this$props.content,
          children = _this$props.children,
          position = _this$props.position,
          contentDisplayMode = _this$props.contentDisplayMode,
          uniqueId = _this$props.uniqueId,
          customOffset = _this$props.customOffset;
      var actualPosition = this.getActualPosition();
      var showContainerPointer = typeof this.props.showContainerPointer !== 'undefined' ? this.props.showContainerPointer : get(this.context, 'Popover.showContainerPointer');
      var offset = customOffset || getOffsetForPosition(actualPosition, showContainerPointer);
      var isVisible = this.getIsVisible();
      return /*#__PURE__*/React.createElement(AnchoredLayer, {
        offset: offset,
        position: position,
        arrowElement: showContainerPointer ? this.state.arrowElement : undefined,
        shouldEscapeWithAnchor: false,
        onFlippedChange: this.handleFlippedChange,
        boundariesElement: boundariesElement,
        content: isVisible && content && /*#__PURE__*/React.createElement(FocusLock, null, /*#__PURE__*/React.createElement(PopoverContainer, {
          backgroundColor: get(this.context, 'Colors.PopoverContainerBackground'),
          borderRadius: get(this.context, 'BorderRadius.PopoverContainerDefault'),
          ref: this.setContainerElement,
          position: actualPosition,
          id: uniqueId,
          role: "menu",
          tabIndex: -1
        }, showContainerPointer && /*#__PURE__*/React.createElement(Arrow, {
          backgroundColor: get(this.context, 'Colors.PopoverContainerBackground'),
          ref: this.setArrowElement,
          position: actualPosition
        }), content))
      }, /*#__PURE__*/React.createElement("div", _extends({
        style: {
          display: contentDisplayMode
        },
        ref: this.setAnchorElement
      }, this.getEventHandlersForInteractionType()), children({
        describedBy: isVisible ? uniqueId : undefined,
        accessibilityAttributes: {
          'aria-haspopup': true,
          'aria-expanded': this.state.isVisible
        }
      })));
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty(Popover, "contextType", ThemingContext);

_defineProperty(Popover, "Positions", AnchoredLayer.Positions);

_defineProperty(Popover, "BoundariesElements", AnchoredLayer.BoundariesElements);

_defineProperty(Popover, "ContentDisplayModes", ContentWrapperDisplayModes);

_defineProperty(Popover, "InteractionTypes", InteractionTypes);

_defineProperty(Popover, "propTypes", {
  onVisibilityChange: PropTypes.func,
  defaultIsVisible: PropTypes.bool,
  isVisible: PropTypes.bool,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.func.isRequired,
  position: PropTypes.oneOf(Object.values(AnchoredLayer.Positions)),
  onClose: PropTypes.func,
  showContainerPointer: PropTypes.bool,
  contentDisplayMode: PropTypes.oneOf(Object.values(Popover.ContentDisplayModes)),
  interactionType: PropTypes.oneOf(Object.values(Popover.InteractionTypes)),
  boundariesElement: PropTypes.oneOf(Object.values(AnchoredLayer.BoundariesElements)),
  uniqueId: PropTypes.string.isRequired,
  customOffset: PropTypes.arrayOf(PropTypes.oneOf([].concat(_toConsumableArray(Object.values(AnchoredLayer.Offset)), _toConsumableArray(Object.values(AnchoredLayer.Offset).map(function (value) {
    return value * -1;
  })))))
});

_defineProperty(Popover, "defaultProps", {
  defaultIsVisible: false,
  position: AnchoredLayer.Positions.BottomCenter,
  boundariesElement: AnchoredLayer.defaultProps.boundariesElement,
  contentDisplayMode: Popover.ContentDisplayModes.InlineFlex,
  interactionType: Popover.InteractionTypes.ToggleClick
});

var PopoverWithUniqueID = withUniqueId(Popover, {
  prefix: PREFIX_ID
});
PopoverWithUniqueID.Positions = AnchoredLayer.Positions;
PopoverWithUniqueID.BoundariesElements = AnchoredLayer.BoundariesElements;
PopoverWithUniqueID.ContentDisplayModes = Popover.ContentDisplayModes;
PopoverWithUniqueID.InteractionTypes = Popover.InteractionTypes;
PopoverWithUniqueID.propTypes = omit(Popover.propTypes, ['uniqueId']);
PopoverWithUniqueID.defaultProps = Popover.defaultProps;
export default PopoverWithUniqueID;